import * as React from 'react';
import { formatDate } from '@utiljs/date';
import { CancelDetailRes } from '../../api';

interface P {
    data?: CancelDetailRes;
}

const reasonMap = [
    '其他',
    '合作后效果不佳',
    '联系不到服务商',
    '服务商未及时解约',
    '与服务商已经达成一致',
    '无理由退款',
    '更换门店重新下单',
    '找到更合适的服务',
    '与服务商达成一致',
    '运营效果不好',
    '服务态度差',
    '对运营方案不认可',
    '收费太高',
    '联系不到服务商',
    '服务商拒绝解约/退款',
];

const statusMap = {
    // 合同状态  1-签约中,2-已生效,4-合作终止,5-签约失败
    1: '签约中',
    2: '已生效',
    4: '合作终止',
    5: '签约失败',
};

const rowData = [
    {
        k: 'wmPoiId',
        label: '商家id',
    },
    {
        k: 'wmPoiName',
        label: '商家名称',
    },
    {
        k: 'startTime',
        label: '合同时间周期',
        render: (v, row) =>
            `${formatDate(row.startTime * 1000, 'yyyy.MM.dd hh:mm')}-${formatDate(
                row.endTime * 1000,
                'yyyy.MM.dd hh:mm',
            )}`,
    },
    {
        k: 'settlementRuleDescList',
        label: '商家结算规则',
        render: (text: string[]) => {
            const arr = text || [];
            return (
                <div>
                    {arr.map(i => (
                        <div>{i}</div>
                    ))}
                </div>
            );
        },
    },
    {
        k: 'name',
        label: '联系人',
    },
    {
        k: 'phone',
        label: '联系电话',
    },
    {
        k: 'contractStatus',
        label: '当前状态',
        render: v => `${statusMap[v] || ''}`,
    },
    {
        k: 'cancelTime',
        label: '申请解约时间',
        render: v => `${formatDate(v * 1000, 'yyyy.MM.dd hh:mm')}`,
    },
    {
        k: 'reason',
        label: '申请解约原因',
        render: (v, row) => `${reasonMap[v]}${v === 0 ? `，${row.extReason || ''}` : ''}`,
    },
];

const CancelTable: React.FC<P> = ({ data }) => (
    <div className="contract-cancel-table">
        {rowData.map(({ k, label, render }) => (
            <div key={`${k}_${data ? data[k] : ''}`} className="contract-cancel-table-row">
                <div className="label">{label}</div>
                <div className="val">{!data ? null : render ? render(data[k], data) : data[k]}</div>
            </div>
        ))}
    </div>
);

export default CancelTable;
